import * as React from "react";
import ScrollView from "../../../../ScrollView/index";
import createAnimatedComponent from "../createAnimatedComponent";
var ScrollViewWithEventThrottle = /* @__PURE__ */ React.forwardRef(
  (props, ref) => /* @__PURE__ */ React.createElement(
    ScrollView,
    {
      scrollEventThrottle: 1e-4,
      ...props,
      ref
    }
  )
);
var AnimatedScrollView_default = createAnimatedComponent(ScrollViewWithEventThrottle);
export {
  AnimatedScrollView_default as default
};
//# sourceMappingURL=AnimatedScrollView.js.map
